import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { api } from "../../../app/applicationSlice";
import { RootState, RootThunk} from "../../../app/store";
import { emptyOf, Pagination } from "../../../models/pagination";
import { fromJson, treatmentCost } from "../../../models/treatmentCost";
import * as service from "../../../services/treatmentCost";
import { treatmentCostParams } from "../../../services/treatmentCost";
interface TreatCostState {
  TreatmentCostData: [],
  Total: 0,
  Current: 1,
 

}
const initialState  = {
  TreatmentCostData: [],
  Total: 0,
  Current: 1,


}as TreatCostState;

const treatmentCostSlice = createSlice({
  name: "treatmentCostSlice",
  initialState,
  reducers: {
    setData(state, action) {
      state.TreatmentCostData = action.payload
    },
    setTotal(state, action) {
      state.Total = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },

   

  },
});

export const { setData, 
  setTotal,
  setCurrent,  } = treatmentCostSlice.actions;

  export const selectTreatmentCostData = (state: RootState) => state.treatmentCost.TreatmentCostData

  export const selectTotal = (state: RootState) => state.treatmentCost.Total
  
  export const selectCurrent = (state: RootState) => state.treatmentCost.Current
  
  
  

export function getTreatmentCostList(params: treatmentCostParams): RootThunk {
  return api(service.getTreatmentCostList(params), (data: any, dispatch) => {
    dispatch(setData(data.records))
    dispatch(setTotal(data.total))
  });
}

export default treatmentCostSlice.reducer;
